import { render, staticRenderFns } from "./auction-work-list.vue?vue&type=template&id=fb8dbbe6&"
import script from "./auction-work-list.vue?vue&type=script&lang=js&"
export * from "./auction-work-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports